import { ActivityType } from 'modules/trainingLibrary/TrainingLibrary/types'

const base = `/${ActivityType.PocketGuides}`

const routes = {
  root: `${base}/details`,
}

export default routes
